import React from 'react';
import {BackTop} from 'antd';

const customStyle = {
  color: '#1890ff',
};

const BackTopStyled = () => <BackTop style={customStyle} />;

export default BackTopStyled;
